import React from "react";

const PromoButton = (props) => {
  const { img, labelOne, labelTwo, link, className = "" } = props;

  return (
    <a href={link}>
      <div className={`promo-button-container ${className}`}>
        {img}
        <div style={{ fontWeight: "bold" }}>{labelOne}&nbsp;</div>
        <div style={{ fontWeight: 400 }}>{labelTwo}</div>
      </div>
    </a>
  );
};

export default PromoButton;
